<template>
  <v-app>
      <div class="res">
       <video autoplay muted loop id="myVideo" class="banner">
            <source src="https://mdbootstrap.com/img/video/Lines.mp4" type="video/mp4">
       </video>
       <h1 class="white--text htg" style="text-align:center">Hey! Read Some Awesome BLOGS</h1>
     </div>

     <div class="man">
       <video autoplay muted loop id="myVideo" style="height:280px">
            <source src="https://mdbootstrap.com/img/video/Lines.mp4" type="video/mp4">
       </video>
       <h4 class="white--text htg" style="text-align:center">Hey! Read Some Awesome BLOGS</h4>
     </div>

     <div style="margin:15px">
         <v-layout row wrap>
          <v-flex xs12 md3 sm12 style="padding:20px" v-for="owl in blog" :key="owl.id">
            <v-card style="border-radius:0px;padding:0px;">
              <img :src=owl.imageSrc width="100%" height="200px"/>
               <h6 style="text-align:center;padding-top:5px;color:#0d47a1">{{owl.title}}</h6>
               <p style="padding:2px;">
                 {{owl.description.slice(0, 200)}}
               </p>
                 <!-- <read-more :disabled="true" more-str="read more" :text="owl.description" link="#" less-str="read less" :max-chars="200"></read-more> -->
                 <div style="text-align:right;margin-top:-15px">
                   <v-btn small flat color="blue" @click="read(owl)">read more</v-btn>
                 </div>
            </v-card>
          </v-flex>
        </v-layout>
     </div>
    
  </v-app>
</template>

<script>
import config from "./../../config.json";
export default {
  data() {
    return {
      
      blog: [],
    };
  },

  methods: {
    getData() {
      this.axios
        .get(config.API + "Blogs2", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.blog = res.data;
          this.$Progress.finish();
          this.getData();
        })
        .catch(err => {
          this.$toaster.error(err.message);
          this.$Progress.fail();
        });
    },
    read(owl) {
     this.$router.push("/blogDetails/" + owl.id);
   }
  },

  mounted() {
    this.getData();
    this.$Progress.start();
  }
};
</script>
<style lang="css" scoped>
.banner {
  /* background-image: url('../../assets/places-divider.jpg');
  background-size: cover; */
  /* height:250px; */
  margin-top: -750px;
}
.htg {
  top: -130px;
  position: relative;
}
.top-left {
  position: absolute;
  top: 8px;
  left: 16px;
}
.tourtheme {
  background-size: cover;
}
.themecap {
  font-family: 'Open Sans', sans-serif;
  padding-top: 130px;
  color: white;
}
.bckclr {
  -webkit-text-fill-color:cornflowerblue
}
.txt_dec:hover {
    text-decoration: none !important;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
</style>